import React from "react";
import { Grid } from "@mui/material";
import "./style.scss";
import "./endStep.scss";

interface IProps {
  stepsNumber: string;
  title: string;
  children: any;
}

const StepsContainer: React.FC<IProps> = ({ children, title, stepsNumber }: IProps) => {
  return (
    <Grid container spacing={0} className={"steps-container shadow"}>
      <Grid item xs={12} className={"steps-number"}>
        <b>{stepsNumber}</b>
      </Grid>
      <Grid item xs={12} className={"steps-title"}>
        <h2>{title}</h2>
      </Grid>
      <Grid item xs={12} className={"steps-children"}>
        {children}
      </Grid>
    </Grid>
  );
};

export default StepsContainer;
